import React from "react";
import { motion } from "framer-motion";

import AuditHero from "../components/audit/AuditHero";
import AuditBenefits from "../components/audit/AuditBenefits";
import AuditProcess from "../components/audit/AuditProcess";
import AuditForm from "../components/audit/AuditForm";

function FreeGrowthAuditPage() {
  return (
    <div
      style={{
        background: "#f8fbfd",
        overflow: "hidden"
      }}
    >
      {/* Hero */}

      <AuditHero />

      {/* Trust Section */}

      <section
        style={{
          padding: "70px 24px",
          background: "#fff"
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto"
          }}
        >
          <motion.div
            initial={{
              opacity: 0,
              y: 30
            }}
            whileInView={{
              opacity: 1,
              y: 0
            }}
            viewport={{
              once: true
            }}
          >
            <div
              style={{
                textAlign: "center",
                marginBottom: "60px"
              }}
            >
              <span
                style={{
                  color: "#21b573",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  textTransform:
                    "uppercase"
                }}
              >
                What You'll Receive
              </span>

              <h2
                style={{
                  color: "#002147",
                  fontWeight: 700,
                  marginTop: "18px",
                  fontSize:
                    "clamp(2rem,4vw,3.4rem)"
                }}
              >
                A Strategic Growth Review,
                Not Generic Advice.
              </h2>

              <p
                style={{
                  maxWidth: "700px",
                  margin:
                    "20px auto 0",
                  color: "#6e6e73",
                  lineHeight: 1.8
                }}
              >
                Every audit is reviewed
                by real specialists and
                focused on uncovering
                opportunities that can
                improve visibility,
                conversion and growth.
              </p>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit,minmax(250px,1fr))",
                gap: "24px"
              }}
            >
              {[
                {
                  title:
                    "SEO Opportunity Analysis",
                  text:
                    "Discover visibility gaps and keyword opportunities."
                },
                {
                  title:
                    "Website Performance Review",
                  text:
                    "Identify UX, speed and technical improvements."
                },
                {
                  title:
                    "Lead Generation Assessment",
                  text:
                    "Review how effectively your website captures demand."
                },
                {
                  title:
                    "Growth Recommendations",
                  text:
                    "Receive practical actions tailored to your business."
                }
              ].map((item) => (
                <motion.div
                  key={item.title}
                  whileHover={{
                    y: -8
                  }}
                  style={{
                    background: "#fff",
                    border:
                      "1px solid rgba(0,33,71,.08)",
                    borderRadius:
                      "24px",
                    padding: "32px",
                    boxShadow:
                      "0 15px 40px rgba(0,33,71,.06)"
                  }}
                >
                  <h4
                    style={{
                      color: "#002147",
                      fontWeight: 700,
                      marginBottom:
                        "16px"
                    }}
                  >
                    {item.title}
                  </h4>

                  <p
                    style={{
                      color: "#6e6e73",
                      lineHeight: 1.8,
                      marginBottom: 0
                    }}
                  >
                    {item.text}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Existing Benefits */}

      <AuditBenefits />

      {/* Existing Process */}

      <AuditProcess />

      {/* Audit Form */}

      <section
        style={{
          padding:
            "90px 24px 120px"
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto"
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "50px"
            }}
          >
            <span
              style={{
                color: "#21b573",
                fontWeight: 700,
                letterSpacing: "1px",
                textTransform:
                  "uppercase"
              }}
            >
              Start Your Audit
            </span>

            <h2
              style={{
                color: "#002147",
                fontWeight: 700,
                marginTop: "18px",
                fontSize:
                  "clamp(2rem,4vw,3.4rem)"
              }}
            >
              Let's Identify Your Next
              Growth Opportunity.
            </h2>

            <p
              style={{
                maxWidth: "700px",
                margin:
                  "20px auto 0",
                color: "#6e6e73",
                lineHeight: 1.8
              }}
            >
              Complete the short audit
              questionnaire and our team
              will review your digital
              presence and provide
              tailored recommendations.
            </p>
          </div>

          <AuditForm />
        </div>
      </section>

      {/* Premium Bottom CTA */}

      <section
        style={{
          padding:
            "100px 24px",
          background:
            "linear-gradient(180deg,#00152d,#002147)"
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center"
          }}
        >
          <motion.div
            initial={{
              opacity: 0,
              y: 30
            }}
            whileInView={{
              opacity: 1,
              y: 0
            }}
            viewport={{
              once: true
            }}
          >
            <h2
              style={{
                color: "#fff",
                fontWeight: 700,
                fontSize:
                  "clamp(2rem,4vw,4rem)",
                lineHeight: 1.1
              }}
            >
              Ready To Accelerate
              Your Growth?
            </h2>

            <p
              style={{
                color:
                  "rgba(255,255,255,.72)",
                maxWidth: "700px",
                margin:
                  "24px auto 40px",
                lineHeight: 1.8
              }}
            >
              Whether you're looking to
              increase leads, improve
              visibility or build a
              stronger digital presence,
              we're ready to help.
            </p>

            <a
              href="/contact"
              style={{
                display:
                  "inline-flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
                padding:
                  "16px 32px",
                borderRadius:
                  "999px",
                textDecoration:
                  "none",
                fontWeight: 700,
                background:
                  "#21b573",
                color: "#fff"
              }}
            >
              Talk To Our Team
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default FreeGrowthAuditPage;